import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  updateCurrentCtr,
  getTicketOrCaseNumberDefault,
  getTicketOrCaseNumber,
  saveContactToHistoryAction,
  setTicketValidation,
  resetState,
} from "../services/current";

interface CurrentState {
  status: string;
  ticketOrCaseNumberDefault: string | null;
  ticketOrCaseNumber: string | null;
  saveContact: {
    history: boolean;
    historyData: Record<string, unknown> | null;
  };
  ticketOrCaseNumberIsValid: boolean;
  ticketOrCaseNumberPersisted: string | null;
}

const initialState: CurrentState = {
  status: "idle",
  ticketOrCaseNumberDefault: null,
  ticketOrCaseNumber: null,
  saveContact: {
    history: false,
    historyData: null,
  },
  ticketOrCaseNumberIsValid: true,
  ticketOrCaseNumberPersisted: null,
};

const currentSlice = createSlice({
  name: "current",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateCurrentCtr.pending, (state) => {
        state.status = "pending";
        state.ticketOrCaseNumberPersisted = null;
      })
      .addCase(updateCurrentCtr.fulfilled, (state, action) => {
        state.status = "success";

        state.ticketOrCaseNumberDefault = null;
        state.ticketOrCaseNumber = null;

        const {
          meta: {
            arg: { ticketOrCaseNumberValue },
          },
        } = action;
        state.ticketOrCaseNumberPersisted = ticketOrCaseNumberValue;
      })
      .addCase(updateCurrentCtr.rejected, (state) => {
        state.status = "rejected";
        state.ticketOrCaseNumberDefault = null;
        state.ticketOrCaseNumber = null;
        state.ticketOrCaseNumberPersisted = null;
      })
      .addCase(getTicketOrCaseNumberDefault, (state, action) => {
        state.ticketOrCaseNumberDefault = action.payload;
      })
      .addCase(getTicketOrCaseNumber, (state, action) => {
        state.ticketOrCaseNumber = action.payload;
      })
      .addCase(saveContactToHistoryAction, (state, action) => {
        state.saveContact.history = action.payload.history;
        state.saveContact.historyData = action.payload.historyData;
      })
      .addCase(setTicketValidation, (state, action) => {
        const payload = action.payload;
        if (state.ticketOrCaseNumberIsValid !== payload) {
          state.ticketOrCaseNumberIsValid = payload;
        }
      })
      .addCase(resetState, (state, action) => {
        const { defaultValue = null } = action.payload;

        state.status = "idle";
        state.ticketOrCaseNumberIsValid = true;
        state.ticketOrCaseNumberPersisted = null;
        state.ticketOrCaseNumberDefault = defaultValue;
        state.ticketOrCaseNumber = null;
      });
  },
});

export default currentSlice.reducer;
